import { render, staticRenderFns } from "./dataDialog.vue?vue&type=template&id=1a2cdcdc"
import script from "./dataDialog.vue?vue&type=script&lang=js"
export * from "./dataDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports